import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import type { ReplacementCarDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const carReplacementSelector = selector<ReplacementCarDTO[] | undefined>({
    key: 'carReplacementSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        const currentProduct = get(getOnsaCurrentProductSelector);
        if (!isLoggedOn || !currentProduct || currentProduct.flavourName !== 'Bilforsikring') {
            return undefined;
        }
        const carReplacements = await OnlineSales.getCarReplacements(
            jobNumber,
            sessionId,
            currentProduct.fixedId
        );

        return carReplacements.at(0) === undefined ? undefined : carReplacements;
    }
});
